import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DialogueBloc } from '@kp/dialogue/dialogue.bloc';
import { DialogueStatus } from '@kp/dialogue/models/dialogue-data-status.model';
import { DialogueLogicKey } from '@kp/dialogue/models/dialogue.model';
import { ReturnUrlService } from '@kp/shared/services/return-url.service';
import { Status } from '@ktypes/models';
import { Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProfileDialogueGuard {
  constructor(
    private _dialogueBloc: DialogueBloc,
    private _returnUrlService: ReturnUrlService,
    private _router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // Short circuit this guard if user has a non-default returnUrl
    if (!this._returnUrlService.isDefaultUrl) {
      return of(true);
    }
    const dialogueUrlTree = this._router.parseUrl('/dialogue/onboarding');
    dialogueUrlTree.queryParams = { logicKey: DialogueLogicKey.dialogue_purposeful_onboarding_v1, returnUrl: '' };
    this._dialogueBloc.getDialogueStatus(DialogueLogicKey.dialogue_purposeful_onboarding_v1);
    return this._dialogueBloc.dialogueStatus$.pipe(
      filter((dataStatus) => dataStatus?.status !== Status.starting && dataStatus?.data != null),
      map(
        (dialogueDataStatus) =>
          dialogueDataStatus.status === Status.error ||
          dialogueDataStatus?.data?.dialogueStatus === DialogueStatus.completed ||
          dialogueUrlTree
      ),
      catchError((error) => {
        console.warn('There was an error trying to check for the dialogue status', error);
        return of(true);
      })
    );
  }
}
